import { ReactNode } from 'react';

const Card = ({ children }: { children: ReactNode }): JSX.Element => {
  return <div className="p-6 rounded-lg bg-white shadow-lg">{children}</div>;
};

export default Card;
